module.exports = __webpack_public_path__ + "static/media/Rectangle 4664.c10536da.png";